import {PageCard} from '../../../../layout/page-card/page-card';
import {ShortCatalogType} from '../../../../provider/catalogs/catalogs-type';

import {AccountLinkingGoogle} from './account-linking-google';

type PropsType = {
    catalogInfo: ShortCatalogType;
};

export function AccountLinkingGoogleCard(props: PropsType): JSX.Element {
    const {catalogInfo} = props;

    return (
        <PageCard title={catalogInfo.name}>
            <AccountLinkingGoogle catalogInfo={catalogInfo} />
        </PageCard>
    );
}
